jQuery(document).ready(function ($) {
  var headerHight = 0;

  $('a[href^="#"]:not(.dns)').click(function () {
    var speed = 200;
    var href = $(this).attr('href');
    var target = $(href == '#' || href === '' ? 'html' : href);
    var position = target.offset().top - headerHight;
    $('html, body').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });



  $('.js-donotcopy').on('contextmenu mousedown mouseup tap', function () {
    return false;
  });
  $('.js-donotcopy').on('touchstart', function () {
    $(this).css({
      'pointer-events': 'none', // iphone対応するための記述
      '-webkit-touch-callout': 'none',
      '-webkit-user-select': 'none',
      '-moz-touch-callout': 'none',
      '-moz-user-select': 'none',
      'touch-callout': 'none',
      'user-select': 'none'
    });
  });
  $('.js-modalhide').hide();
  $('.js-modalbox').modaal();
  $('.js-modal-inline').modaal();
  $('.js-modal-youtube').modaal({
    type: 'video'
  });


  $('.js-maintab').on('click', function () {
    var tabId;
    if (!$(this).hasClass('is-active')) {
      tabId = $(this).attr('href');
      console.log(tabId);
      $('.main-program-tabbox.is-shown').removeClass('is-shown');
      $(tabId).addClass('is-shown');
      $('.js-maintab').removeClass('is-active');
      $(this).addClass('is-active');
    }
    return false;

  });

  var jsOwl = $('.js-owl');
  jsOwl.on('initialized.owl.carousel', function (event) {
    $('.js-modalbox').modaal();
  });
  jsOwl.owlCarousel(
    {
      responsive: {
        0: {
          items: 1.3,
          nav: false,
        },
        761: {
          items: 4,
          nav: true,
        }

      },
      autoplay: false,
      smartSpeed: 500,

      loop: true,
      dots: false,
      margin: 16,
      mouseDrag: true,
      autoHeight: false,
      center: true
    }
  );




});
